<template>
  <!-- D: 서브 전용 상품 컴포넌트 -->
  <div class="c-product-card">
    <div class="product-thumb">
      <button type="button" class="thumb-button" @click="emit('detail', item)">
        <div class="product-img">
          <img
            class="no-image"
            v-if="isNoPcImage"
            src="@/assets/images/common/img_no_product.svg"
            alt="No Image"
          />
          <img
            v-else
            :src="imageFilePath"
            alt=""
            @error="() => (imageErrorYn = true)"
          />
        </div>
        <div class="thumb-bottom">
          <p class="text">제품상세보기</p>
          <i class="c-icon icon-plus"></i>
        </div>
      </button>
    </div>
    <div class="product-info">
      <div v-show="!productBadgeEmptyYn" class="c-product-badge">
        <span v-if="item.setgdYn === 'Y'" class="badge type-skyblue">
          SET 제품
        </span>

        <span v-if="item.zzlqdCls == 'A'" class="badge type-purple">
          주제
        </span>
        <span v-if="item.zzlqdCls == 'B'" class="badge type-mint">
          경화제
        </span>
        <span v-if="item.zzlqdCls == 'C'" class="badge type-blue">
          경화촉진제
        </span>
        <span v-if="item.zzlqdCls == 'D'" class="badge type-violet">
          회석제
        </span>

        <span v-if="item.zzlqdtyCls == 'A'" class="badge type-olive">
          1액형
        </span>
        <span v-if="item.zzlqdtyCls == 'B'" class="badge type-olive">
          2액형
        </span>
        <span v-if="item.zzlqdtyCls == 'C'" class="badge type-olive">
          3액형
        </span>
      </div>
      <div class="c-product-category">
        <span class="path">{{ item.prodh1t }}</span>
        <span class="path">{{ item.prodh2t }}</span>
        <span class="path">{{ item.prodh3t }}</span>
      </div>
      <div class="product-code">{{ item.matnr }}</div>
      <strong class="product-name">{{ item.zzmaktx }}</strong>
      <div class="info-bottom">
        <p class="price">
          <strong class="system">{{
            Number(item.kbetr).toLocaleString()
          }}</strong
          >원
        </p>
        <div class="c-btn-area type-product">
          <button
            type="button"
            class="c-button type-white type-xsmall type-icon"
            @click="addCartItemFromFashion({ product: { ...item } })"
          >
            <i class="c-icon icon-basket-product"></i>
            <span class="sr-only">장바구니</span>
          </button>
          <button
            type="button"
            class="c-button type-primary type-xsmall"
            @click="emit('globalOrder', item)"
          >
            <span>바로주문</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <ProdInfoPop
    v-if="isShowProdInfoPop"
    v-bind="prodInfoPopProps"
    @close="() => (isShowProdInfoPop = false)"
  />
</template>

<script setup>
import {
  onMounted,
  defineProps,
  defineEmits,
  ref,
  inject,
  computed,
} from "vue";
import Utils from "@/js/utils";
import ProdInfoPop from "../prod/prodInfoPop.vue";

const props = defineProps({
  item: {
    type: Object,
    require: true,
  },
});

const emit = defineEmits(["detail", "globalOrder"]);

const addCartItemFromFashion = inject("addCartItemFromFashion");
const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;
const item = ref(props.item);
const imageErrorYn = ref(false);
const prodInfoPopProps = ref({
  matnr: null,
}); // 제품상세팝업
const isShowProdInfoPop = ref(false);

onMounted(() => {});

const productBadgeEmptyYn = computed(() => {
  return (
    item.value.setgdYn !== "Y" &&
    item.value.zzlqdCls !== "A" &&
    item.value.zzlqdCls !== "B" &&
    item.value.zzlqdCls !== "C" &&
    item.value.zzlqdCls !== "D" &&
    item.value.zzlqdtyCls !== "A" &&
    item.value.zzlqdtyCls !== "B" &&
    item.value.zzlqdtyCls !== "C"
  );
});

const isNoPcImage = computed(() => {
  return (
    Utils.isBlank(item.value.filePath) ||
    Utils.isBlank(item.value.physFileNm) ||
    imageErrorYn.value
  );
});

const imageFilePath = computed(() => {
  return FILE_CDN_URL + "/" + item.value.filePath + "/" + item.value.physFileNm;
});
</script>
